import { Link } from '@tanstack/react-router';
import cn from 'classnames';

import { CandidateCard } from 'components/CandidateCard';
import {
  SubmissionChip,
  type SubmissionStatus,
} from 'components/SubmissionChip';
import {
  CandidateTier,
  type PipelineCandidateSearchFilterSortResponse,
} from 'client/types.gen';

type Candidate = PipelineCandidateSearchFilterSortResponse;

export function RecommendationListItem({
  selected,
  candidate,
  onClick,
  status,
}: {
  candidate: Candidate;
  selected: boolean;
  onClick: VoidFunction;
  status?: SubmissionStatus;
}) {
  return (
    <Link
      className={cn(
        'flex min-w-0 flex-1 rounded-[12px] border transition-colors duration-200 hover:shadow-elevation-300',
        { 'border-blue-500': selected },
      )}
      onClick={onClick}
      to="."
    >
      <CandidateCard
        company={candidate.current_company}
        image={candidate.image}
        is_client={candidate.tier === CandidateTier.EXECUTIVE_CLIENT}
        name={candidate.name}
        profile_image_url={candidate.profile_image_url}
        role={candidate.current_role}
      >
        {<SubmissionChip status={status} />}
      </CandidateCard>
    </Link>
  );
}
